import { availableLanguages, type SupportedLanguage } from '@core/types/i18n'

export function isSupportedLanguage(
  lang: string | undefined
): lang is SupportedLanguage {
  return !!lang && availableLanguages.some(({ value }) => lang === value)
}
